<template>
    <DCard>
        <DCol class="pt-2 pb-2">
            <DButton
                class="ms-3"
                :label="__('customers.contracts.reseller_contracts.only_active')"
                @click="applyOnlyActiveFilter"
            />
            <DButton
                class="ms-3"
                icon="filter-off"
                :label="__('messages.actions.reset_filter')"
                @click="resetFilters"
            />
        </DCol>
        <DTable
            :fields="[
                { key: 'id', label: __('customers.contracts.reseller_contracts.id') },
                { key: 'quantity', label: __('customers.contracts.reseller_contracts.quantity') },
                { key: 'description', label: __('customers.contracts.reseller_contracts.description') },
                { key: 'external_product_id', label: __('customers.contracts.reseller_contracts.external_product_id') },
                { key: 'product_identifier', label: __('customers.contracts.reseller_contracts.product_identifier') },
                { key: 'external_id', label: __('customers.contracts.reseller_contracts.external_id') },
                { key: 'start_date', label: __('customers.contracts.reseller_contracts.start_date') },
                { key: 'end_date', label: __('customers.contracts.reseller_contracts.end_date') },
                { key: 'price', label: __('customers.contracts.reseller_contracts.price') },
                { key: 'billed_until_date', label: __('customers.contracts.reseller_contracts.billed_until_date') },
                { key: 'billing_cycle', label: __('customers.contracts.reseller_contracts.billing_cycle') }
            ]"
            class="tableText"
            :items="resellerContracts.data"
        >
            <template #price="{item}">
                <td>
                    {{ priceFormatForDisplay(item.price, 2, customer.market_region_id) }}
                </td>
            </template>
            <template #end_date="{item}">
                <td>
                    {{ item.end_date === null ? '' : item.end_date }}
                </td>
            </template>
            <template #billed_until_date="{item}">
                <td>
                    {{ item.billed_until_date === null ? '' : item.billed_until_date }}
                </td>
            </template>
            <template #billing_cycle="{item}">
                <td>
                    {{ billingCycle(item.billing_cycle) }}
                </td>
            </template>
        </DTable>
        <DPagination
            v-if="resellerContracts.last_page > 1"
            :active-page="resellerContracts.current_page"
            :pages="resellerContracts.last_page"
            align="center"
            @update:activePage="changePage"
        />
    </DCard>
</template>

<script>
import billingCycle from '~@/Mixins/billingCycle'
import priceFormat from '~@/Mixins/priceFormat'

export default {
    name: 'ResellerContractsTable',
    mixins: [
        billingCycle,
        priceFormat
    ],
    props: {
        customer: {
            type: Object,
            default: () => { return {} }
        },
        resellerContracts: {
            type: Object,
            default: () => { return {} }
        },
        filters: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['changePage'],
    data () {
        return {
            pageFilters: this.filters ?? {}
        }
    },
    methods: {
        changePage (page) {
            this.$emit('changePage', page, {
                page: page,
                filters: this.pageFilters
            })
        },
        applyOnlyActiveFilter () {
            this.pageFilters.only_active = true
            this.changePage(this.resellerContracts.current_page)
        },
        resetFilters () {
            this.pageFilters = {}
            this.changePage(this.resellerContracts.current_page)
        }
    }
}
</script>

<style lang="scss" scoped>
.button {
    background-color: rgb(26, 77, 128);
    color: white;
    font-size: 16px;
}
.tableText {
    text-align: center
}
</style>
